var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_104_2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.18678 0.27299L12.7135 5.53921C13.0955 5.90319 13.0955 6.49177 12.7135 6.85189L11.7951 7.72701C11.4131 8.091 10.7954 8.091 10.4175 7.72701L6.5 3.99419L2.5825 7.72701C2.2005 8.091 1.5828 8.091 1.2049 7.72701L0.2865 6.85189C-0.0955 6.4879 -0.0955 5.89932 0.2865 5.53921L5.81322 0.27299C6.18709 -0.0909998 6.80478 -0.0909998 7.18678 0.27299Z",
  fill: "#212121"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_104_2"
}, /*#__PURE__*/React.createElement("rect", {
  width: 13,
  height: 8,
  fill: "white",
  transform: "translate(13 8) rotate(-180)"
})));

function SvgIcArrUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrUp);
export default __webpack_public_path__ + "static/media/ic_arr_up.1028acc52072a143ff96b865148bc7e2.svg";
export { ForwardRef as ReactComponent };